import { useMemo } from 'react';
import { Analytics, logEvent as fbLogEvent, getAnalytics } from 'firebase/analytics';
import { app } from 'core/config';
import { useAppSelector } from './use-app-selector';

const useAnalytics = () => {
  const cookiesAccepted = useAppSelector((state) => state.layout.cookiesAccepted);
  const analytics = useMemo<Analytics | undefined>(() => {
    if (cookiesAccepted) {
      return getAnalytics(app);
    }
    return undefined;

  }, [cookiesAccepted]);

  const logEvent = (eventName: string, eventParams?: { [key: string]: string | undefined }) => {
    if (analytics) {
      fbLogEvent(analytics, eventName, eventParams);
    }
  };

  return { analytics, logEvent };
};
export { useAnalytics };
